import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'df-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.css']
})
export class DetailComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
